// Import and register all your controllers

import { application } from "./application"

// Eager load all controllers
import AccordionController from "./accordion_controller"
import AnchorController from "./anchor_controller"
import AppController from "./app_controller"
import BuildController from "./build_controller"
import CarouselController from "./carousel_controller"
import CookiesController from "./cookies_controller"
import DropdownController from "./dropdown_controller"
import PricingController from "./pricing_controller"
import ScrollerController from "./scroller_controller"

application.register("accordion", AccordionController)
application.register("anchor", AnchorController)
application.register("app", AppController)
application.register("build", BuildController)
application.register("carousel", CarouselController)
application.register("cookies", CookiesController)
application.register("dropdown", DropdownController)
application.register("pricing", PricingController)
application.register("scroller", ScrollerController)
